import { ContainerModule } from "inversify";
import { di } from "@dp-instant/core";
import { TypesSocial } from "@dp-instant/interfaces";
import { AdsModule, PaymentsModelBase, UserScore, LeaderboardGlobalExternal } from "@dp-instant/social";
import { SocialModelTelegram } from "./SocialModelTelegram";
import { UserDataTelegram } from "./UserDataTelegram";
import { TelegramUser } from "./TelegramUser";

export const TelegramSocialModule = new ContainerModule(() => {
    // Load base AdsModule (provides ads.adAction, ads.manager, ads.initAction)
    di.load(AdsModule);

    // Social bindings (same pattern as other platforms)
    di.bind(TypesSocial.model).to(SocialModelTelegram).inSingletonScope();
    di.bind(TypesSocial.cookie).to(UserDataTelegram).inSingletonScope();
    di.bind(TypesSocial.payments).to(PaymentsModelBase).inSingletonScope();
    di.bind(TypesSocial.user).to(TelegramUser);
    di.bind(TypesSocial.userScore).to(UserScore);
    di.bind(TypesSocial.leaderboardGlobal).to(LeaderboardGlobalExternal).inSingletonScope();
    di.bind(TypesSocial.leaderboardContext).to(LeaderboardGlobalExternal).inSingletonScope();

    // Dummy user for leaderboard placeholder
    let dummyUser: any;
    di.bind(TypesSocial.dummyUser).toDynamicValue((context) => {
        if (!dummyUser) {
            dummyUser = context.container.get(TypesSocial.user);
            const photo = `data:image/svg+xml;charset=utf-8,${encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="320" height="320"><path d="M0 0h320v320H0V0z" fill="#fff"/><path d="M320 0H0v320h320V0zM160 66.7c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm0 189.3c-33.4 0-62.7-17.1-80-42.9.3-26.5 53.4-41.1 80-41.1s79.6 14.6 80 41.1c-17.3 25.8-46.6 42.9-80 42.9z"/></svg>')}`;
            dummyUser.init({
                getUniqueID: () => "unknown",
                getPhoto: () => photo,
            });
        }
        return dummyUser;
    });
});
